/* ============================================================
   CANDID COFFEE — candid.js (global)
   Toast, scroll-reveal, nav state, mobile menu, cursor.
   Commerce (cart/product) handled in later milestones.
============================================================ */
(function () {
  'use strict';

  /* ── Toast ── */
  var _tt;
  window.showToast = function (msg) {
    var el = document.getElementById('toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(_tt);
    _tt = setTimeout(function () { el.classList.remove('show'); }, 3200);
  };

  /* ── Smooth scroll to an id ── */
  window.goTo = function (id) {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  /* ── Scroll reveal (scope optional: re-run on injected content) ── */
  function initReveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.rv, .rv-l');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.07 });
    els.forEach(function (el) { if (!el.classList.contains('in')) obs.observe(el); });
  }
  window.Candid = window.Candid || {};
  window.Candid.initReveal = initReveal;

  /* ── Nav: light background once scrolled off a dark hero ── */
  function initNav() {
    var nav = document.getElementById('mainNav');
    if (!nav) return;
    function check() {
      var dark = document.querySelectorAll('.section-dark, .section-dark2, .bestsellers, .exp-section, .blog-sec, [data-nav-dark]');
      /* Probe the nav's own icon row (handles the announcement-bar offset too):
         the nav is only "dark" while a dark section actually covers that row.
         This flips to the light (dark-text) nav the instant light content
         reaches the icons, so the logo/hamburger are never white-on-white
         in the narrow window where a hero's bottom edge passes the nav. */
      var navRect = nav.getBoundingClientRect();
      var probe = navRect.top + navRect.height / 2;
      var inDark = false;
      dark.forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.top <= probe && r.bottom >= probe) inDark = true;
      });
      nav.classList.toggle('on-light', !inDark);
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
  }

  /* ── Announcement bar: keep fixed nav below it while at top ── */
  function initAnnouncement() {
    var ann = document.querySelector('.ann-bar');
    var nav = document.getElementById('mainNav');
    if (!ann || !nav) return;
    function offset() {
      var h = ann.offsetHeight;
      nav.style.top = Math.max(0, h - window.scrollY) + 'px';
    }
    offset();
    window.addEventListener('scroll', offset, { passive: true });
    window.addEventListener('resize', offset, { passive: true });
  }

  /* ── Mobile menu ── */
  function initMobileMenu() {
    var burger = document.getElementById('hamburger');
    var menu = document.getElementById('mobMenu');
    if (!burger || !menu) return;
    function toggle(open) {
      menu.classList.toggle('open', open);
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    burger.addEventListener('click', function () { toggle(!menu.classList.contains('open')); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { toggle(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') toggle(false);
    });
  }

  /* ── Custom cursor (pointer devices only) ── */
  function initCursor() {
    var cur = document.getElementById('cur');
    var curR = document.getElementById('curR');
    if (!cur || !curR) return;
    /* Pointer devices only — never on touch/coarse pointers or small screens (mobile CX) */
    if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches || window.innerWidth <= 1024) return;
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cur.style.left = mx + 'px'; cur.style.top = my + 'px';
    }, { passive: true });
    (function anim() {
      rx += (mx - rx) * 0.1; ry += (my - ry) * 0.1;
      curR.style.left = rx + 'px'; curR.style.top = ry + 'px';
      requestAnimationFrame(anim);
    })();
    document.querySelectorAll('a,button,[onclick],.f-opt,.bean-chip').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cur.classList.add('h'); curR.classList.add('h'); });
      el.addEventListener('mouseleave', function () { cur.classList.remove('h'); curR.classList.remove('h'); });
    });
  }

  /* ── Desktop mega / dropdown: forgiving hover (stays open, small close delay) ── */
  function initMegaMenu() {
    if (!window.matchMedia('(hover:hover)').matches) return;
    var items = document.querySelectorAll('.nav-link.has-drop');
    if (!items.length) return;
    var DELAY = 240; // ms grace period after the cursor leaves before closing

    // Keep a wide panel inside the viewport by nudging it left when it would overflow.
    function place(item) {
      var panel = item.querySelector('.mega, .drop');
      if (!panel) return;
      panel.style.left = '0px';
      var margin = 16;
      var r = panel.getBoundingClientRect();
      var over = r.right - (window.innerWidth - margin);
      if (over > 0) { panel.style.left = (-over) + 'px'; r = panel.getBoundingClientRect(); }
      if (r.left < margin) { panel.style.left = ((parseFloat(panel.style.left) || 0) + (margin - r.left)) + 'px'; }
    }

    items.forEach(function (item) {
      var t = null;
      function open() { clearTimeout(t); item.classList.add('open'); place(item); }
      function close() { clearTimeout(t); t = setTimeout(function () { item.classList.remove('open'); }, DELAY); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
    });
    window.addEventListener('resize', function () {
      items.forEach(function (i) { if (i.classList.contains('open')) place(i); });
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') items.forEach(function (i) { i.classList.remove('open'); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initNav();
    initAnnouncement();
    initMobileMenu();
    initMegaMenu();
    initCursor();
  });
})();
